import { useMemo } from 'react';
import { getFeatureFlagConfig } from 'shared/constants/feature-flags';
import { FeatureFlag } from 'shared/models/feature-flag';
import { getCurrentEnvironment } from 'shared/utils/environment-utils';
import { isFeatureEnabledInEnvironment } from 'shared/utils/feature-flag-utils';

export { getCurrentEnvironment } from 'shared/utils/environment-utils';

type UseFeatureFlagReturn = {
  isEnabled: boolean;
};

const currentEnvironment = getCurrentEnvironment();
const currentVersion = import.meta.env.PACKAGE_VERSION;

export const useFeatureFlag = (feature: FeatureFlag): UseFeatureFlagReturn => {
  const isEnabled = useMemo(() => {
    const config = getFeatureFlagConfig(feature);

    if (config.disabledIn.includes(currentEnvironment)) {
      return false;
    }

    return config.enabledIn.some((envConfig) => isFeatureEnabledInEnvironment(envConfig, currentEnvironment, currentVersion));
  }, [feature, currentEnvironment, currentVersion]);

  return {
    isEnabled,
  };
};
